import { FetchAPI } from "@renedelangel/helpers";

import { urlServidor } from '../../helpers';

// Seguros y siniestros comparten estructura; solo cambia el sufijo (Seg / Sin)
function CrearMutaciones(sufijo) {

    const ADD = `
    mutation add($input: InputAddCatEstadoSeguimiento!) {
        addCatEstadoSeguimiento${sufijo}(input: $input) {
            estadoID
            nombre
        }
    }`;

    const UPDATE = `
    mutation update($input: InputUpdateCatEstadoSeguimiento!) {
        updateCatEstadoSeguimiento${sufijo}(input: $input) {
            estadoID
            nombre
        }
    }`;

    const DELETE = `
    mutation delete($input: InputDeleteCatEstadoSeguimiento) {
        deleteCatEstadoSeguimiento${sufijo}(input: $input)
    }`;

    const ejecutar = async (query, variables, token, campo) => {
        try {
            let resultado = await FetchAPI.graphql({
                token,
                variables,
                url: urlServidor,
                query
            });
            return resultado[campo];
        } catch ({ message }) { throw new Error(message); }
    };

    return {
        add: (variables, token) => ejecutar(ADD, variables, token, `addCatEstadoSeguimiento${sufijo}`),
        update: (variables, token) => ejecutar(UPDATE, variables, token, `updateCatEstadoSeguimiento${sufijo}`),
        remove: (input, token) => ejecutar(DELETE, { input }, token, `deleteCatEstadoSeguimiento${sufijo}`)
    };
}

const mutacionesSeg = CrearMutaciones("Seg");
const mutacionesSin = CrearMutaciones("Sin");

export const addEstadoSeguimientoSeg = mutacionesSeg.add;
export const updateEstadoSeguimientoSeg = mutacionesSeg.update;
export const deleteEstadoSeguimientoSeg = mutacionesSeg.remove;
export const addEstadoSeguimientoSin = mutacionesSin.add;
export const updateEstadoSeguimientoSin = mutacionesSin.update;
export const deleteEstadoSeguimientoSin = mutacionesSin.remove;
